// ICONS
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";

export const siteLinks = [
  {
    page_Name: "faqs",
    page_Link: "/faqs",
  },
  {
    page_Name: "contact",
    page_Link: "/contact",
  },
  {
    page_Name: "menu",
    page_Link: "/menu",
  },
];

export const getInTouch = [
  {
    contact_Info: "ahmed@gmail.com",
    contact_Icon: faEnvelope,
  },
  {
    contact_Info: "+201025521486",
    contact_Icon: faPhone,
  },
  {
    contact_Info: "Cairo, Egypt",
    contact_Icon: faLocationDot,
  },
];

export const workingHours = [
  {
    working_Hours_Info: "tue - sat: 11:00 - 23:00",
  },
  {
    working_Hours_Info: "sun: 12:00 - 22:00",
  },
  {
    working_Hours_Info: "mon: closed",
  },
];
